module.exports = __webpack_public_path__ + "static/media/assyrian_text_03.dbe57e23.jpg";